<template>
  <form-modal
    :ref="modalName"
    :name="modalName"
    :type="modalType"
    class="ModalManager"
    title="Manager"
    submit-name="Set Manager"
    :submit-disabled="!item"
    full-height
    @submit="submit"
    @[Events.BEFORE_CLOSE]="cleanQuery"
    @[Events.AFTER_CLOSE]="modalClosed"
  >
    <template v-if="item">
      <p class="text-gray-700">
        Managers have a
        <span class="text-gray-900 font-medium">global scope</span> by default
        so they can manage the entire landscape, but you can limit the scope to
        specific actors.
      </p>
      <lm-logo v-if="actors.length === 0" />
      <lm-tree-selector v-else v-model="actors" />
    </template>
  </form-modal>
</template>

<script>
import {mapGetters} from 'vuex'
import {Events, ModalType, Modal} from '@/lib/definitions'
import EventHub from '@/lib/eventHub'
import LmLogo from '@/components/ui/LmLogo'
import FormModal from '@/components/modals/FormModal'
import LmTreeSelector from '@/components/ui/LmTreeSelector'

export default {
  name: 'ModalManager',
  components: {LmLogo, LmTreeSelector, FormModal},
  data() {
    return {
      Events,
      modalName: Modal.MANAGER,
      modalType: ModalType.SUBMODAL,
      invitation: false,
      item: null, // User | Invitation
      actors: []
    }
  },
  computed: mapGetters(['getUserByID', 'getActors', 'currentInvitation']),
  mounted() {
    this.modalRef = this.$refs[this.modalName]
    this.resolveItemType()
    this.resolveActors()
  },
  methods: {
    resolveItemType() {
      const user = this.$route.query.user
      const email = this.$route.query.email
      if (user) {
        this.item = this.getUserByID(user)
      } else if (
        email &&
        email === (this.currentInvitation && this.currentInvitation.email)
      ) {
        this.invitation = true
        this.item = this.currentInvitation
      }
    },
    resolveActors() {
      if (!this.item) return
      if (this.item.managedActors.length > 0) {
        this.actors = this.item.managedActors.slice()
      } else {
        // New role. Set all actors
        for (let key in this.getActors) {
          const actor = this.getActors[key]
          this.actors.push(actor._id)
        }
      }
    },
    submit() {
      const payload = {
        role: 'manager',
        invitation: this.invitation,
        id: this.invitation ? this.item.email : this.item._id,
        actors: this.actors
      }
      this.$store
        .dispatch('setRole', payload)
        .then(() => this.modalRef.submitSuccess())
        .catch(error => {
          if (error.devCode !== 500) {
            error = error.devMessage
          }
          this.modalRef.submitFails(error)
        })
    },
    cleanQuery() {
      this.$router.removeKeyFromQuery('user')
      this.$router.removeKeyFromQuery('email')
    },
    modalClosed({fromSubmit}) {
      if (fromSubmit) {
        let id = this.invitation ? this.item.email : this.item.username
        EventHub.emit(Events.SHOW_SNACKBAR, `${id} is now a Manager`)
      }
      this.$store.commit('removeCurrentInvitation')
    }
  }
}
</script>
